import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import Dashboard from "./pages/Dashboard";
import RawMaterials from "./pages/RawMaterials";
import Packaging from "./pages/Packaging";
import FinishedGoods from "./pages/FinishedGoods";
import Manufacturing from "./pages/Manufacturing";
import VoiceImport from "./pages/VoiceImport";
import Chat from "./pages/Chat";
import Setup from "./pages/Setup";
import Settings from "./pages/Settings";
import { hasLedgerDir } from "./services/inventory";

export default function App() {
  const [ready, setReady] = useState<boolean | null>(null);

  useEffect(() => {
    hasLedgerDir().then(setReady).catch(() => setReady(false));
  }, []);

  if (ready === null) {
    return (
      <div className="min-h-screen bg-navy-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-citilux-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!ready) {
    return <Setup onComplete={() => setReady(true)} />;
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="raw-materials" element={<RawMaterials />} />
        <Route path="packaging" element={<Packaging />} />
        <Route path="finished-goods" element={<FinishedGoods />} />
        <Route path="manufacturing" element={<Manufacturing />} />
        <Route path="voice-import" element={<VoiceImport />} />
        <Route path="chat" element={<Chat />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
